export function setContext(context, data) {
  window.GTMContext[context] = {
    ...(window.GTMContext[context] || {}),
    ...data,
  };
}

export function clearContext(context) {
  window.GTMContext[context] = {};
}

export function removeContextKey(context, keys) {
  if (window.GTMContext[context] && keys && keys.length) {
    keys.forEach((key) => {
      delete window.GTMContext[context][key];
    });
  }
}

export function getContext(context) {
  return window.GTMContext[context] || {};
}
